import { PostRequestJson } from "src/shared/api";
import { config } from "src/config/config";
import { MvpApiVersion } from "./api_types";

// TODO: rentAssetAPI と同様に amountToPay を options から削除する。
//   amountToPay は「販売価格 - 残高使用額」で求められるので渡す必要がない。
//   むしろ渡すようになっていると渡す値を間違える可能性があるので、渡さないようにする。
export const buyAssetAPI = (options: any) => {
  let url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.buy_asset}`;
  if (options.amountToPay === 0) {
    url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.buy_asset_for_free}`;
  }

  let data = {
    owner_account_id: options.ownerAccountId,
    kid: options.kid,
    asset_token_id: options.asset_token_id,
    balance_to_use: options.balanceToUse,
    asset_sale_price: options.assetSalePrice,
    lang: options.lang,
  };
  return PostRequestJson(url, data, {});
};

export const buyGroupAssetsAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.buy_group_assets}`;
  const data = {
    number_of_purchases: options.numberOfPurchases,
    group_id: options.groupId,
  };
  return PostRequestJson(url, data, {});
};

export const rentAssetAPI = (options: any) => {
  const amountToPay = options.assetRentPrice - options.balanceToUse;

  let url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.rent_asset}`;
  if (amountToPay === 0) {
    url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.rent_asset_for_free}`;
  }

  const data = {
    owner_account_id: options.ownerAccountId,
    kid: options.kid,
    asset_token_id: options.assetTokenID,
    balance_to_use: options.balanceToUse,
    asset_rent_price: options.assetRentPrice,
    rental_period_seconds: options.rentalPeriodSeconds,
    lang: options.lang,
  };
  return PostRequestJson(url, data, {});
};

export const tradeAssetAPI = (options: any) => {
  let url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.trade_asset}`;
  let data = {
    my_trading_asset_token_id: options.myTradingSerialId,
    offering_serial_token_id: options.requestedSerialId,
    offering_serial_owner_account_id: options.requestedSerialOwnerAccountId,
  };
  return PostRequestJson(url, data, {});
};

export const cancelPurchaseAPI = (options: any) => {
  let url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.cancel_purchase}`;
  let data = {
    kid: options.kid,
    serial_number: options.serialNumber,
  };
  return PostRequestJson(url, data, {});
};
